export const COOKIES_CONSENT_STORAGE_KEY = 'cookies_usage_consent';